import React, { useMemo } from 'react';
import { createFinancialDetailBreakdownTableData } from '../financial_detail_utils/createFinancialDetailBreakdownTableData';
import { useTranslation } from 'react-i18next';
import { Table } from '@rd-web-markets/shared/dist/util';
const ResumeOfCostTable = _ref => {
  let {
    contractor,
    columnWidth
  } = _ref;
  const {
    t
  } = useTranslation();
  const getTableWidth = headers => headers.length * columnWidth;
  const {
    headers,
    rows
  } = useMemo(() => {
    return createFinancialDetailBreakdownTableData(contractor.cost_calculations, t, columnWidth);
  }, [contractor.cost_calculations, t, columnWidth]);
  if (!headers.length) return null;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: getTableWidth(headers) + 'px'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    showControls: false
  }));
};
export default ResumeOfCostTable;